import { ROLES } from '../constants'
import { useHasRole } from './use-has-role'
import { useHasActiveSKU } from './use-has-valid-sku'

/**
 * Check if user has System Manager role AND an active SKU
 */
export const useHasActiveSystemManager = (): boolean => {
	const hasRole = useHasRole(ROLES.SystemManager)
	const hasActiveSKU = useHasActiveSKU()
	return hasRole && hasActiveSKU
}
